import { IBackgroundData, IBorderRadiusData, IPxHeightData, IWidgetVisibility, SelfPosition, VisibilityData, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface ITextWidgetData extends IWidgetVisibility {
    readonly type: "TextWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    html?: string | null;
    background: IBackgroundData;
    style: ITextWidgetStyle | null;
}

export interface ITextWidgetStyle extends IAnimatedWidget {
    padding: number;
    thickness: number;
    borderColor: string;
    borderRadius?: IBorderRadiusData | null;
    heightData?: IPxHeightData | null;
    minHeight: number;
    verticalAlignment: SelfPosition;
}

export class TextWidgetData {

    public static get defaultData(): ITextWidgetData {
        return {
            type: "TextWidget",
            placeType: "Section",
            background: {
                style: {
                    color: "rgba(255, 255, 255, 0)"
                }
            },
            style: this.defaultStyle,
            visibility: VisibilityData.defaultData()
        };
    }

    public static get defaultStyle(): ITextWidgetStyle {
        return {
            padding: 0,
            thickness: 0,
            borderColor: "#D2D2D5",
            borderRadius: {
                topLeftPx: 0,
                topRightPx: 0,
                bottomLeftPx: 0,
                bottomRightPx: 0
            },
            heightData: {
                height: 28
            },
            minHeight: 28,
            verticalAlignment: "top",
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

}
